import './App.css';

import {
  BrowserRouter as Router,
  Route,
} from "react-router-dom";

import Provider from "./Provider/Provider";

import MainModal from "./components/MainModalComponent";


function App() {
  return (
    <Router basename={'/censodecarga'}>
      <Provider>
      <Route path='/' component={MainModal} />
      </Provider>
    </Router>
  );
}

export default App;
